import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import Alert from 'react-s-alert';
import { change, Field, reduxForm, reset } from 'redux-form';
import classNames from 'classnames';

import DomainModal from './domain_Modal';
import TargetModal from '../target/target_Modal';
import { renderCheckBox, renderTextField } from '../../../../../components/reduxFields';
import { alertConfirmation, resetFiltersAndSorting } from '../../../../../actions/utilAction';
import SortingCustom from '../../../../../components/SortingCustom';
import { getDomainList,getMasterData, deleteDomain } from './actions/domainActions';
import PaginatorCustom from '../../../../../components/paginationCustom';
import Program from '../program/index';
import { CommonButton } from '../../../../../components/buttons';
import { UpdateDCArchiveStatus } from '../../actions/CurriculumLibrariesActions';

const stylescss = {
    checkbox: {
      marginBottom: 16,
    },
  };


class Domain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openTargetModal: false,
            domainId: null,
            isProgram: false,
            curriculumLibraryId: props.curriculumLibraryIdForDomain,
            domainIdForProgram: null,
            domainName: '',
            // Target modal master data state starts
            masterDomains: [],
            masterPrograms: [],
            desiredDailyTrials: [],
            autoOpenOrder: [],
            targetType: [],
            responsePercentage: [],
            consecutiveDays: [],
            firstTrialMustBeIndependent: [],
            selectedLibraryIds: [],     
            ShowArchivedOnly : false,       
            // Target modal master data state ends

        }
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        this.handleSearchDomains = this.handleSearchDomains.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
        this.CheckDomain = this.CheckDomain.bind(this);
        this.ResetAllCheckBoxes = this.ResetAllCheckBoxes.bind(this);        
    }

    componentWillMount() {
        this.loadData();
        let masterData = { 'masterdata': 'MASTERDOMAINS,MASTERPROGRAMS,MASTERDESIREDDAILYTRIALS,MASTERAUTOOPENORDER,MASTERTARGETTYPE,MASTERRESPONSEPERCENTAGE,MASTERCONSECUTIVEDAYS,MASTERFIRSTTRIALMUSTBEINDEPENDENT' };
        this.props.getMasterData(masterData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saved_domain && nextProps.saved_domain !== this.props.saved_domain) {
            this.loadData();
        }
        if (nextProps.deleted_domain && nextProps.deleted_domain !== this.props.deleted_domain) {
            this.loadData();
        }
        let masterDomains = [];
        let masterPrograms =[];
        if(nextProps.masterDomains !== null && nextProps.masterDomains.length !== 0) {
            masterDomains = nextProps.masterDomains.filter(obj => {
                return obj.libraryId === this.state.curriculumLibraryId
            })
        }
        if(nextProps.masterPrograms !== null && nextProps.masterPrograms.length !== 0) {
            masterPrograms = nextProps.masterPrograms
        }
        this.setState({
            masterDomains: masterDomains,
            masterPrograms: masterPrograms,
            desiredDailyTrials: nextProps.desiredDailyTrials !== null && nextProps.desiredDailyTrials,
            autoOpenOrder: nextProps.autoOpenOrder !== null && nextProps.autoOpenOrder,
            targetType: nextProps.targetType !== null && nextProps.targetType,
            responsePercentage: nextProps.responsePercentage !== null && nextProps.responsePercentage,
            consecutiveDays: nextProps.consecutiveDays !== null && nextProps.consecutiveDays,
            firstTrialMustBeIndependent: nextProps.firstTrialMustBeIndependent !== null && nextProps.firstTrialMustBeIndependent
        });

        if (nextProps.archiveBatchDCStatus && nextProps.archiveBatchDCStatus !== this.props.archiveBatchDCStatus) {
            this.setState({ selectedLibraryIds : [] },()=>{
              this.ResetAllCheckBoxes();
              this.loadData();
            });      
          }  
    }

    componentWillUnmount() {
        Alert.closeAll();
    }

    onClickHandler = (e, obj) => {
        this.setState({
            domainIdForProgram: obj.id,
            isProgram: true,
            domainName: obj.domainName,
        })
        this.loadData()
    }

    onBackClick = () => {
        this.setState({
            domainIdForProgram: null,
            isProgram: false,
            domainName: ''
        })
        this.loadData();
    }

    handleAlertArchiveBatchDomainsClick = (event) => {
        this.props.UpdateDCArchiveStatus(this.state.selectedLibraryIds.toString(), true, 'MasterDomain');
        Alert.closeAll();
      }
    
      handleArchiveBatchDomainsClick = (event) => {
        Alert.warning('Are you sure you want to archive selected domain(s)?', {
          position: 'bottom-right',
          effect: 'slide',
          timeout: 10000,
          customFields: {
            displayComponent: true,
            handleButtonClick: this.handleAlertArchiveBatchDomainsClick,
            //id: obj.id,
          },
        });
      }

      handleAlertUnArchiveBatchDomainsClick = (event) => {
        this.props.UpdateDCArchiveStatus(this.state.selectedLibraryIds.toString(), false, 'MasterDomain');
        Alert.closeAll();
      }
    
      handleUnArchiveBatchDomainsClick = (event) => {
        Alert.warning('Are you sure you want to unarchive selected domain?', {
          position: 'bottom-right',
          effect: 'slide',
          timeout: 10000,
          customFields: {
            displayComponent: true,
            handleButtonClick: this.handleAlertUnArchiveBatchDomainsClick,
            //id: obj.id,
          },
        });
      }

      ResetAllCheckBoxes()
      {
        this.props.domainData != null && this.props.domainData && this.props.domainData.data.forEach((obj, Index) => {
            let idCheck = `Claims[${Index}].Chk`;                
            this.props.dispatch(change('ManageDomainForm', idCheck, false));                
        });
      }

      CheckDomain(e, index, data) {    
        let selectedLibraryIds = this.state.selectedLibraryIds;        
        let isChecked = e.target.checked;
        if (isChecked) {     
            selectedLibraryIds.push(data.id);              
        } else {     
            index = selectedLibraryIds.findIndex((value) => value === data.id);
            if (index >= 0) {
                selectedLibraryIds.splice(index, 1);         
            }      
        }
        this.setState({ selectedLibraryIds });
      }

    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null, ShowArchivedOnly: this.state.ShowArchivedOnly ? '1' : '0', },
            pageNumber: page_number || 1,
        };
        this.props.getDomainList(searchObj, this.props.curriculumLibraryIdForDomain);
    }

    handleOpen = (type) => {
        Alert.closeAll();
        if(type === "addDomain") {
            this.setState({ open: true, domainId: null });
        } else {
            this.setState({ openTargetModal: true, domainId: null, open: false });
        }
    };

    handleClose = () => {
        this.setState({ open: false, openTargetModal: false });
    };

    handleSearchDomains() {
        return false;
    }

    handleSearchChange(event) {
        if (event.target.value.length > 2) {
            this.filter.searchText = event.target.value;
            this.loadData();
        } else if (event.target.value.length === 0) {
            this.filter.searchText = '';
            this.loadData();
        }
    }

    handleReset = () => {
        Alert.closeAll();
        this.props.dispatch(reset('ManageDomainForm'));
        resetFiltersAndSorting(this.filter, 'id', true);
        this.filter.sort_Column = '';
        this.filter.sort_order = '';
        this.setState({ ShowArchivedOnly : false  }, ()=>{this.loadData();});
      
    };

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_order = col_order;
            this.loadData();
        }
    }

    handleEditClick = (event, obj) => {
        Alert.closeAll();
        this.setState({ open: true, domainId: obj.id });
    }

    handleAlertClick = (event, domainId) => {
        this.props.deleteDomain(domainId);
        Alert.closeAll();
    }

    handleDeleteClick = (event, obj) => {
        alertConfirmation('Are you sure you want to delete domain details?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleAlertClick,
                id: obj.id,
            },
        });
    }

    handleAdvanceFilterCheck = (input, name) => {
        this.setState({ [name]: input.target.checked },
          () => {
            this.loadData();
          });
      }

    renderData(domainList) {
        domainList = domainList || [];
        if (!domainList.length) {
            return (
                <tr> 
                    <td colSpan="4">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return domainList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td width="5%">
                        <div className="table_custom-check">
                        <Field
                            name={`Claims[${index}].Chk`}
                            component={renderCheckBox}
                            onChange={(e) => this.CheckDomain(e, index, Obj)}
                            style={stylescss.checkbox}
                        />
                        </div>
                    </td>
                    <td><a href="#" onClick={(e) => this.onClickHandler(e, Obj)}><i className="fa fa-folder" style={{ color: '#F0E68C' }}></i>&nbsp;{Obj.domainName}</a></td>
                    <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td>
                    <td>
                        <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                        <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                    </td>
                </tr>
            )
        })
    }

    domainRender = () => {
        const { handleSubmit, domainData } = this.props;
        let domainList = (domainData && domainData.data) || [];
        let domainMeta = (domainData && domainData.meta) || null
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        return (
            <div>
                <h2 className="page_title">Manage Curriculum Libraries {' > '} {this.props.libraryName} {' > '} Domains</h2>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <div className="modalwindow">
                            <div className="row">
                                <div className="col-10 col-sm-10 col-md-10">
                                    <RaisedButton className="ml_15  mb_15" label="Back" primary={true} onTouchTap={() => this.props.onBackClick()} />
                                {/* </div> */}
                                {/* <div className="col-sm-3"> */}
                                    <RaisedButton className="ml_15 mb_15" label="Add Domain" primary={true} onTouchTap={() => this.handleOpen('addDomain')} />
                                {/* </div> */}
                                {/* <div className="col-sm-4"> */}
                                    <RaisedButton  className="ml_15 mb_15" label="Add Goals/Targets" primary={true} onTouchTap={() => this.handleOpen('addGoals')} />
                                {/* </div> */}
                                {/* <div className="col-sm-3"> */}
                                    <CommonButton className={this.state.selectedLibraryIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedLibraryIds.length > 0 && !this.state.ShowArchivedOnly ? false : true} label="Mark as Archived" onTouchTap={(e) => this.handleArchiveBatchDomainsClick(e)} />
                                {/* </div> */}
                                {/* <div className="col-sm-3"> */}
                                    <CommonButton className={this.state.selectedLibraryIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedLibraryIds.length > 0 && this.state.ShowArchivedOnly ? false : true} label="Mark as Unarchived" onTouchTap={(e) => this.handleUnArchiveBatchDomainsClick(e)} />
                                </div>                                
                            </div>
                            <div className="row mt-20">
                                <div className="col-sm-4 field-mr">
                                    <Field
                                    name="ShowArchivedOnly"
                                    label="Show Archived Only"
                                    component={renderCheckBox}
                                    onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowArchivedOnly')}
                                    />
                                </div>
                                <div className="col-sm-8">
                                    <div className="row end-flex">
                                        <div className="col-sm-6 mtm-27">
                                            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchDomains)}>
                                                <Field
                                                    name="domain"
                                                    floatingLabelText="Search"
                                                    maxLength='25'
                                                    onChange={this.handleSearchChange}
                                                    component={renderTextField}
                                                />
                                            </form>
                                        </div>
                                        <div className="reset-btn col-sm-3 btn_rt">
                                            <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.open && <DomainModal domainId={this.state.domainId} closeDialog={this.handleClose} curriculumLibraryId={this.state.curriculumLibraryId} />}
                            {this.state.openTargetModal && <TargetModal  
                            closeDialog={this.handleClose}
                            curriculumLibraryId={this.state.curriculumLibraryId}
                            masterDomains={this.state.masterDomains}
                            masterPrograms={this.state.masterPrograms}
                            desiredDailyTrials={this.state.desiredDailyTrials}
                            autoOpenOrder={this.state.autoOpenOrder}
                            targetType={this.state.targetType}
                            responsePercentage={this.state.responsePercentage}
                            consecutiveDays={this.state.consecutiveDays}
                            firstTrialMustBeIndependent={this.state.firstTrialMustBeIndependent}
                            />}
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive mt-15">
                                    <table className={tableClass}>
                                        <thead>
                                            <tr>
                                                <th width="5%"></th>
                                                <th width="50%"><SortingCustom noSort={!domainList.length} setSortColumn={this.setSortColumn} columnName='domainName' displayName='Name' /></th>
                                                <th width="25%">Active</th>
                                                <th width="20%">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.renderData(domainList)}
                                        </tbody>
                                    </table>
                                    {domainMeta && domainMeta['totalPages'] ?
                                        <PaginatorCustom data={domainMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            this.state.isProgram === false 
            ?
            this.domainRender()
            :
            <Program
            domainIdForProgram={this.state.domainIdForProgram}  
            libraryName={this.props.libraryName}
            domainName={this.state.domainName}
            onBackClick={this.onBackClick}
            masterDomains={this.state.masterDomains}
            masterPrograms={this.state.masterPrograms}
            desiredDailyTrials={this.state.desiredDailyTrials}
            autoOpenOrder={this.state.autoOpenOrder}
            targetType={this.state.targetType}
            responsePercentage={this.state.responsePercentage}
            consecutiveDays={this.state.consecutiveDays}
            firstTrialMustBeIndependent={this.state.firstTrialMustBeIndependent}
            curriculumLibraryId={this.state.curriculumLibraryId}
            />
        )
    }
}

Domain = reduxForm({
    form: 'ManageDomainForm',
})(Domain);

function mapStateToProps(state) {
    // console.log('masterDtaa---', state.domain.master_data)
    return {
        loading: state.domain.loading,
        domainData: state.domain.domainList,
        saved_domain: state.domain.saved_domainList,
        deleted_domain: state.domain.deleted_domainList,
        masterDomains: state.domain.master_data ? state.domain.master_data.masterDomains : [],
        masterPrograms: state.domain.master_data ? state.domain.master_data.masterPrograms : [],
        desiredDailyTrials: state.domain.master_data ? state.domain.master_data.desiredDailyTrials : [],
        autoOpenOrder: state.domain.master_data ? state.domain.master_data.autoOpenOrder : [],
        targetType: state.domain.master_data ? state.domain.master_data.targetType : [],
        responsePercentage: state.domain.master_data ? state.domain.master_data.responsePercentage : [],
        consecutiveDays: state.domain.master_data ? state.domain.master_data.consecutiveDays : [],
        firstTrialMustBeIndependent: state.domain.master_data ? state.domain.master_data.firstTrialMustBeIndependent : [],
        archiveBatchDCStatus: state.curriculumLibraries.archiveBatchDCStatus,    
    }
}

export default connect(mapStateToProps, { getDomainList,getMasterData,deleteDomain, UpdateDCArchiveStatus })(Domain);


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/domain/index.js